<template>
  <div data-component="app-launcher-header-actions">
    <or-button
      data-button="cancel"
      variant="text"
      :disabled="isUpdating"
      @click="$emit('cancel')"
    >
      {{ $t('HITL.common.actions.cancel') }}
    </or-button>

    <or-button
      data-button="save"
      :loading="isUpdating"
      @click="$emit(actionsType)"
    >
      {{ label }}
    </or-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrButtonV3 as OrButton } from '@onereach/ui-components-25';
import { ACTIONS_TYPE_PROP } from '../constants';

export default defineComponent({
  name: 'AppLauncherHeaderActions',
  components: { OrButton },
  props: {
    actionsType: ACTIONS_TYPE_PROP,
    label: {
      type: String,
      default: '',
    },
    isUpdating: Boolean,
  },
  emits: ['save', 'update', 'cancel'],
});
</script>

<style lang="scss">
[data-component='app-launcher-header-actions'] {
  display: flex;
  gap: var(--s-4);
}
</style>
